const mutation = {
  // 设置地区
  SET_SITE: (state, site) => {
    state.site = site
  }
}
export default mutation
